import React, {useState} from 'react';
import emptybox from "./../../assets/images/empty-box.png";

const FollowupsTicketInfo: React.FC<{ticket: any}> = (props) => {

    const testComment = "2020-03-11 04:32:59 - System Administrator (Additional comments)\nThe server appears to be back online. It's responding to internal pings. We're currently working to confirm that the dependent Web applications have connectivity.\n\n2020-03-11 04:26:20 - System Administrator (Work notes)\nServer is now responding to internal requests.\n\n2020-03-11 04:24:38 - Tim Dietrich (Additional comments)\nServer is not responding to pings.\n\n2020-03-11 04:24:18 - Tim Dietrich (Additional comments)\nDatabase Server LS7 is down.\n\n"
    //const rawComments = props.ticket["comments"].split("\n\n");
    const rawComments = testComment.split("\n\n");
    let comments: any[] = [];
    if(rawComments[0] !== "") {
        rawComments.forEach((comment: string) => {
            if(comment !== "") {
                let commentSections = comment.split("\n");
                comments.push({"header": commentSections[0], "content": commentSections[1]});
            }
        });
    }

    return(
        <div className="card wrapup-box collapse show mt-3" id="ticketInfo">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className='m-0'>Ticket Information</h6>
            </div>
            {props.ticket["ticketFound"] === "true" ? (
                <div style={{width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <div style={{marginBottom: "3rem"}}>
                        <label className='mb-2' style={{position: "absolute", left: "0", marginLeft: "2rem", marginTop: "2rem"}}>Short description</label>
                    </div>
                    <span style={{marginTop: "2rem", width: "95%"}}>
                        {props.ticket["shortDescription"]}
                    </span>
                    <div style={{marginTop: "2rem", marginBottom: "2rem", outline: "1px solid #f5f5f5", width: "95%"}}/>
                    <div style={{marginBottom: "3rem"}}>
                        <label className='mb-2' style={{position: "absolute", left: "0", marginLeft: "2rem"}}>Comments and work notes</label>
                    </div>
                    <ul className="callback-list d-flex flex-column list-unstyled" style={{alignItems: "center", width: "100%"}}>
                        {comments.length !== 0 ? (
                            comments.map((comment: any, index: number) => {
                                return(
                                    <li key={index+1} style={{width: "95%"}}>
                                        <div className="d-flex justify-content-between mb-1">
                                            <div>
                                                <div className="contact-no me-3"><strong>{comment["header"]}</strong></div>
                                                <div className="date-time">{comment["content"]}</div>
                                            </div>
                                        </div>
                                    </li>
                                );
                            })
                        ):(
                            <div className='empty-data'>
                                <img className='empty-icon' src={emptybox} alt="empty box icon" />
                                <h4>No comments or work notes available</h4>
                            </div>
                        )
                        }
                    </ul>
                </div>
            ):(
                <div className="card-body height-400">
                    <div className='empty-data'>
                        <img className='empty-icon' src={emptybox} alt="empty box icon" />
                        <h4>{props.ticket["ticketFound"] === "error" ? "Ticket number not found" : "No data available"}</h4>
                    </div>
                </div>
            )}
        </div>
    );
}

export default FollowupsTicketInfo;